import { useMemo } from "react"
import { format } from "date-fns"
import { getDateFnsLocale } from "@/v2-common/utils/utils.date"
import Select from "@/v2-ui/select"
import { YEARS, getMonthOptions } from "./dateRangePicker.utils"

export type DateRangePickerNavProps = {
  label?: string
  month: Date
  onMonthChange(month: Date): void
}

function DateRangePickerNav(props: DateRangePickerNavProps) {
  const { label, month, onMonthChange } = props

  const monthOptions = useMemo(
    () => getMonthOptions(month.getFullYear()),
    [month],
  )

  return (
    <div className="ui-date-picker-nav-group">
      {label && <span className="ui-date-picker-nav-label">{label}</span>}
      <Select
        value={month.getMonth().toString()}
        onValueChange={(v) => {
          const next = new Date(month)
          next.setMonth(Number(v))
          onMonthChange(next)
        }}
      >
        <Select.Trigger className="ui-date-picker-nav-trigger ui-date-picker-nav-trigger-month">
          <Select.Value />
        </Select.Trigger>
        <Select.Content>
          {monthOptions.map((m, i) => (
            <Select.Item key={i} value={i.toString()}>
              {format(m, "MMMM", { locale: getDateFnsLocale() })}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>

      <Select
        value={month.getFullYear().toString()}
        onValueChange={(v) => {
          const next = new Date(month)
          next.setFullYear(Number(v))
          onMonthChange(next)
        }}
      >
        <Select.Trigger className="ui-date-picker-nav-trigger ui-date-picker-nav-trigger-year">
          <Select.Value />
        </Select.Trigger>
        <Select.Content>
          {YEARS.map((y) => (
            <Select.Item key={y} value={y.toString()}>
              {y}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
    </div>
  )
}

export default DateRangePickerNav
